import { styled } from "@mui/material/styles";
import { Typography as MuiTypography } from "@mui/material";

export const SessionSelectionWidgetContainer = styled("div")(({ theme }) => ({
  backgroundColor: theme.colors["neutral.900"],
  borderRadius: '1rem',
  padding: '1.5rem',
  position: 'sticky',
  top: '5rem',
  marginTop: '6rem',
  height: 'fit-content',

  "@media (max-width: 600px)": {
    height: 'auto',
    marginTop: 0,
    position: 'fixed',
    top: 'inherit',
    bottom: 0,
    left: 0,
    width: '100%',
    zIndex: 1
  },
}));

export const SectionHeaderTitle = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: theme.space._200,
  flexGrow: 1,
  paddingBottom: '1.5rem'
}));

export const SectionSubTitleTypography = styled(MuiTypography)(({ theme }) => ({
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes["md"],
  fontWeight: theme.fontWeights.semibold,
  lineHeight: theme.lineHeights.slim,
  color: theme.colors["neutral.500"],
}));

export const SectionTitleTypography = styled(MuiTypography)(({ theme }) => ({
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes["2xl"],
  fontWeight: theme.fontWeights.bold,
  lineHeight: theme.lineHeights.slim,
  color: theme.colors.white,
}));

export const LabelTypography = styled(MuiTypography)(({ theme }) => ({
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.md,
  lineHeight: theme.lineHeights.base,
  color: theme.colors["neutral.400"],
  marginBottom: '.5rem'
}));

export const InputSection = styled("div")(({ theme }) => ({
  marginTop: '1.5rem'
}));

export const UnSelectedSessionContainer = styled("div")(({ theme }) => ({
  backgroundColor: theme.colors["neutral.800"],
  border: `2px dashed ${theme.colors["neutral.500"]}`,
  borderRadius: '.5rem',
  display: "flex",
  justifyContent: 'center',
  padding: '.5rem',
  marginBottom: '1.5rem',
  minWidth: '18.5rem'
}));

export const SelectedSessionContainer = styled("div")(({ theme }) => ({
  backgroundColor: theme.colors["neutral.800"],
  border: `2px solid ${theme.colors["lime.500"]}`,
  borderRadius: '.5rem',
  display: "flex",
  justifyContent: 'space-between',
  padding: '.5rem',
  marginBottom: '1.5rem',
  minWidth: '18.5rem'
}));

export const SelectedSessionLabel = styled(MuiTypography)(({ theme }) => ({
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.md,
  lineHeight: theme.lineHeights.base,
  color: theme.colors["neutral.400"],
}));

export const SelectedSessionName = styled(MuiTypography)(({ theme }) => ({
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.md,
  fontWeight: theme.fontWeights.semibold,
  lineHeight: theme.lineHeights.shorter,
  color: theme.colors["neutral.50"],
  marginTop: '.2rem'
}));

export const DateContainer = styled("div")(({ theme }) => ({
  backgroundColor: theme.colors["neutral.50"],
  textAlign: 'center',
  padding: '.5rem',
  borderRadius: '.2rem',
  minWidth: '5rem',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center'
}));

export const SelectedSessionYear = styled(MuiTypography)(({ theme }) => ({
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.md,
  fontWeight: theme.fontWeights.bold,
  color: theme.colors["neutral.950"],
}));

export const SelectedSessionDay = styled(MuiTypography)(({ theme }) => ({
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.sm,
  fontWeight: theme.fontWeights.semibold,
  color: theme.colors["neutral.600"],
}));

export const TrashButton = styled("div")(({ theme }) => ({
  padding: '0 0 0 .5rem',
  color: theme.colors["neutral.400"],
  cursor: 'pointer'
}));

export const RegisterIcon = styled("div")(({ theme }) => ({
  color: theme.colors["neutral.50"],
  transform: 'rotate(45deg) scale(1.5)',
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
  pointerEvents: 'none',
  marginTop: '3.5rem'
}));

export const RegisterSuccessTitle = styled(MuiTypography)(({ theme }) => ({
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes["2xl"],
  fontWeight: theme.fontWeights.semibold,
  color: theme.colors["neutral.50"],
  marginTop: '1.5rem',
  textAlign: 'center'
}));

export const RegisterSuccessText = styled(MuiTypography)(({ theme }) => ({
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.sm,
  color: theme.colors["neutral.400"],
  textAlign: 'center',
  marginBottom: '2rem'
}));